import {
    TOGGLE_LOADING_INDICATOR, SET_MESSAGE_RESPONSE, MessageResponse, SystemState, SystemActionTypes, TOGGLE_ERROR_INDICATOR,
    SET_ERROR_MESSAGE_RESPONSE, SET_WARNING_MESSAGE_RESPONSE_POPUP, SET_MY_USER
} from "./types";

export const initialState: SystemState = {
    showLoading: false,
    showError: false,
    messageResponse: null,
    messageErrorResponse: null,
    title: '',
    showWarningPopup: false,
    showMyUser: false
};

export function systemReducer(
    state = initialState,
    action: SystemActionTypes
): SystemState {
    switch (action.type) {
        case SET_MY_USER:
            return {
                ...state,
                showMyUser: action.payload as boolean
            };
        case TOGGLE_LOADING_INDICATOR:
            return {
                ...state,
                showLoading: action.payload as boolean
            };
        case SET_WARNING_MESSAGE_RESPONSE_POPUP:
            return {
                ...state,
                showWarningPopup: action.payload as boolean
            };
        case SET_MESSAGE_RESPONSE:
            return {
                ...state,
                messageResponse: action.payload as MessageResponse
            };
        case TOGGLE_ERROR_INDICATOR:
            return {
                ...state,
                showError: action.payload as boolean
            };
        case SET_ERROR_MESSAGE_RESPONSE:
            return {
                ...state,
                messageErrorResponse: action.payload as MessageResponse
            };
        default:
            return state;
    }
}
